import { withFormik } from 'formik';

import { IEmailTemplates, PageProps } from 'types';
import { getErrorMessage } from 'utilities';

import { EmailTemplatesDisplay } from '..';

export interface IEmailTemplatesPage {
  onPost?: (args: any) => Promise<void>;
  isSending: boolean;
  globalConfigs: {
    portalName: string;
    emailClosing: string;
    customerServiceMessage: string;
    textContrastColor: string;
    autoMailerFromName: string;
  };
  auth0OrganizationInfo: {
    display_name: string;
    metadata: {
      client_name?: string;
      client_portal_name?: string;
      customer_service?: string;
      email_closing?: string;
      text_contrast_color?: string;
    };
    branding: {
      colors: {
        primary: string;
      };
      logo_url: string;
    };
  };
  templates: IEmailTemplates;
}

export const EmailTemplatesDisplayWrapper = withFormik<
  IEmailTemplates & PageProps<IEmailTemplates> & IEmailTemplatesPage,
  any
>({
  mapPropsToValues: ({ templates }): Pick<IEmailTemplates, 'templates'> => {
    return {
      templates,
    };
  },
  handleSubmit: async (props, formik) => {
    const { name, endpoint, values, ...rest } = props;
    const {
      resetForm,
      props: { onSubmit, onSuccessToast, onFailureToast },
    } = formik;

    if (onSubmit) {
      try {
        await onSubmit(rest);
        onSuccessToast && onSuccessToast();
        resetForm({ values: rest });
      } catch (error) {
        const err = error as any;
        const msg = getErrorMessage(error) || err.message;
        onFailureToast && onFailureToast(msg);
      }
    }
  },
})(EmailTemplatesDisplay);
